<div class="modal-content">
    <div class="modal-header">
        <h6 class="modal-title" id="modal-title-default" [translate]="'INSERIR_TEMPLATE'"></h6>
        <button id="btn-fechar-modal-inserir-template" type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="modal.close()">
            <i class="mdi mdi-close"></i>
        </button>
    </div>
    <div class="modal-body" style="min-height: 400px !important;">
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label>Templates</label>
                    <select-padrao id="select-template-inserir-template" [entidade]="'selectTemplate'" [returnObj]="true" (selectChange)="insereTemplate($event)" [params]="tipo"></select-padrao>
                </div>
            </div>
        </div>
        <div class="row" *ngIf="conteudo_template !== '' && conteudo_template !== undefined">
            <div class="col-12">
                <div class="form-group">
                    <label [translate]="'PREVISUALIZACAO_CONTEUDO_TEMPLATE'"></label>
                    <span class="form-control" [innerHTML]="conteudo_template" style="height: auto; word-wrap: break-word"></span>                 
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button id="btn-adicionar-template-inserir-template" type="button" class="btn btn-success badge-pill" [disabled]="isEmpty(conteudo_template)" (click)="adicionarTemplate(conteudo_template)">
            <span [translate]="'INSERIR'"></span>
        </button>
    </div>
</div>